import { Card, Group, SimpleGrid, Stack, Text } from '@mantine/core'
import { formatEuros } from '@markku/utils'

interface CostsSummaryCardProps {
  year: number
  totalBudget: number
  totalCost: number
}

export function CostsSummaryCard({
  year,
  totalBudget,
  totalCost,
}: CostsSummaryCardProps) {
  return (
    <Card
      withBorder
      radius="lg"
      p="lg"
      style={{
        background: 'linear-gradient(135deg, #F0F9FF 0%, #E0F2FE 100%)',
        borderColor: 'var(--mantine-color-blue-2)',
      }}
    >
      <Stack gap="md">
        <Text fw={600}>Vuoden {year} yhteenveto</Text>

        <SimpleGrid cols={2} spacing="md">
          <Stack gap={4}>
            <Text size="xs" c="dimmed" tt="uppercase">
              Budjetoitu
            </Text>
            <Text size="xxl" fw={700} c="blue.7">
              {formatEuros(totalBudget)}
            </Text>
          </Stack>

          <Stack gap={4}>
            <Text size="xs" c="dimmed" tt="uppercase">
              Toteutunut
            </Text>
            <Text size="xxl" fw={700}>
              {formatEuros(totalCost)}
            </Text>
          </Stack>
        </SimpleGrid>

        {/* Budget variance */}
        {totalBudget > 0 && totalCost > 0 && (
          <Group justify="space-between">
            <Text size="sm" c="dimmed">
              Budjettiero
            </Text>
            <Text
              size="sm"
              fw={600}
              c={totalCost > totalBudget ? 'red.7' : 'green.7'}
            >
              {totalCost > totalBudget ? '+' : ''}
              {formatEuros(totalCost - totalBudget)}
            </Text>
          </Group>
        )}
      </Stack>
    </Card>
  )
}
